import type { CacheProvider } from "@serophin/shared";

export type ClientOptions = {
  /** Whether a session exists. Signed-out reads of user data answer empty instead of calling the API. Defaults to always true. */
  isSignedIn?: () => boolean | Promise<boolean>;
};

let cacheProvider: CacheProvider | undefined;
let signedInCheck: NonNullable<ClientOptions["isSignedIn"]> = () => true;

export const initClient = (provider: CacheProvider, options: ClientOptions = {}): void => {
  cacheProvider = provider;
  signedInCheck = options.isSignedIn ?? (() => true);
};

export const getCache = (): CacheProvider => {
  if (!cacheProvider) {
    throw new Error("Client not initialized. Call initClient() first.");
  }
  return cacheProvider;
};

export const isSignedIn = async (): Promise<boolean> => signedInCheck();
